import React, { useState } from 'react';
import ModalWrapper from '../../common/Modal/ModalWrapper';
import Button from '../../common/Button';
import { toggleModal } from '../../../reducers/modalReducer';
import { useDispatch } from 'react-redux';
import Heading from '../../common/Heading';

const EditGroupAddModal = ({
    modalType,
    companies,
    parentCompany,
    handleChildCompany,
    companiesGroup,
    updateGroupCompany,
    setCompaniesGroup,
    user,
    profileClass
}) => {
    const dispatch = useDispatch();
    const [selectedCompanies, setSelectedCompanies] = useState([]);

    const onCloseHandler = () => {
        dispatch(toggleModal({ open: "" }));
        setSelectedCompanies([]);
        setCompaniesGroup({});
    };

    // Filter out parent and existing children - only show companies that can be added
    const existingChildIds = parentCompany?.childrenCompanies?.map(c => c._id) || [];
    const availableCompanies = companies?.filter(c =>
        c._id !== parentCompany?._id &&
        c.group !== 'Parent' &&
        (c.group === 'Standard' || !c.group) &&
        !existingChildIds.includes(c._id)
    ) || [];

    const handleCheckboxChange = (event, companyId) => {
        handleChildCompany({
            event,
            companyId,
            group: companiesGroup[companyId]?.['group'],
            selected: 'true'
        });
        if (event.target.checked) {
            setSelectedCompanies(prev => [...prev, companyId]);
        } else {
            setSelectedCompanies(prev => prev.filter(id => id !== companyId));
        }
    };

    return (
        <ModalWrapper modalType={modalType} onCloseHandler={onCloseHandler}>
            <div className=''>
                <Heading text={`Add to ${parentCompany?.cName || 'Group'}`} />
                <div className='bottom-company-area' style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {availableCompanies.length > 0 ? availableCompanies.map((childCompany, idx) => (
                        <div key={`add-child-${idx}`}
                            style={{ backgroundColor: '#F0F2FD80' }}
                            className='company-detail-box df aic w95 bg1 bs1px brss bo45 br20px px0-75rem mb1rem'>
                            <span className="checkbox active w2rem h2rem pr mr0-75rem">
                                <input
                                    onChange={(event) => handleCheckboxChange(event, childCompany['_id'])}
                                    id={`addChildCompany-${childCompany['_id']}`}
                                    className="bo5 bw2px bss cp td250 w2rem h2rem br5px"
                                    type="checkbox"
                                />
                            </span>
                            <div className="company-detail df fww br10px fs1rem mb1rem mt1rem w100 aic jcsb">
                                <div className='df fdc jcfs aifs'>
                                    <h4 className='fs1rem mr1rem w11rem c15'>
                                        {childCompany['cName']}
                                    </h4>
                                    {childCompany['subscription']
                                        ? <h2 className="fs11px c45 mra tal w2rem">{childCompany['subscription']?.toUpperCase()}</h2>
                                        : <h2 className="fs11px c45 mra tal mra w3rem">INACTIVE</h2>
                                    }
                                </div>
                                <span className='mr0-5rem df jsc w4rem'>
                                    <div className='df w4rem jcc'>
                                        <span className='df username-area'>
                                            <div className="df aic" style={{ flexDirection: "column", alignItems: "end" }}>
                                                {childCompany?.['creatorId']?.['profile']
                                                    ? <img className={`w2rem h2rem df jcc aic br100 mr0-5rem bs4px brss bo34 ${profileClass}`} src={childCompany['creatorId']['profile']} data-tooltip={childCompany['creatorId']?.['firstName'] ? (childCompany['creatorId']['firstName'] + " " + (childCompany['creatorId']?.['lastName'] || "")) : ""} />
                                                    : <span data-tooltip={childCompany['creatorId']?.['firstName'] ? (childCompany['creatorId']['firstName'] + " " + (childCompany['creatorId']?.['lastName'] || "")) : ""} className={`w2rem h2rem df jcc aic br100 mr0-5rem fs0-75rem bg3 c1 ${profileClass}`}>{childCompany['creatorId']?.['firstName'] ? (childCompany['creatorId']['firstName'][0] + (childCompany['creatorId']?.['lastName']?.[0] || "")) : "?"}</span>
                                                }
                                            </div>
                                        </span>
                                    </div>
                                </span>
                                <div className='dropdown-company w8rem px0-5rem py0-5rem'>
                                    <select
                                        defaultValue="Subsidiary"
                                        name="dropdown"
                                        className="fs0-75rem w100 p0-5rem br5px"
                                        onChange={(e) => handleChildCompany({ companyId: childCompany['_id'], group: e.target.value })}
                                        id={`group-${childCompany['_id']}`}
                                    >
                                        <option value='Subsidiary'>Subsidiary</option>
                                        <option value='Associate'>Associate</option>
                                    </select>
                                </div>
                                <div className='percentage-area ml1rem w5rem'>
                                    <span className='input-area'>
                                        <input
                                            defaultValue={companiesGroup[childCompany['_id']]?.['percentage'] || ''}
                                            onChange={(e) => handleChildCompany({
                                                companyId: childCompany['_id'],
                                                group: companiesGroup[childCompany['_id']]?.['group'],
                                                percentage: e.target.value
                                            })}
                                            placeholder='0%'
                                            id={`percentage-${childCompany['_id']}`}
                                            type="text"
                                            className="fw600 bg1 bs1px brss bo31 br10px py0-5rem px1rem percentage w100"
                                            min="1"
                                            max="100"
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>
                    )) : (
                        <div className='tac py2rem'>
                            <p className='c7 fs0-875rem'>No available companies to add. All companies are either already in a group or are parent companies.</p>
                        </div>
                    )}
                </div>
                <div className='mb2rem mt3rem df jcc'>
                    <Button
                        btnType="warning"
                        text="Add to Group"
                        disabled={selectedCompanies.length === 0}
                        onClick={() => updateGroupCompany('Add')}
                    />
                </div>
            </div>
        </ModalWrapper>
    );
};

export default EditGroupAddModal;
